


































import {Component} from 'vue-property-decorator';
import Report from '@/pdf/Report';
import CompanySustainability from '@/pdf/pages/CompanySustainability.vue';
import GTSustainability from '@/pdf/pages/GTSustainability.vue';
import Table from '@/presentation/slides/Table.vue';
import PageFooter from '@/pdf/components/PageFooter.vue';

@Component({
  components: {
    PageFooter,
    Table,
    CompanySustainability,
    GTSustainability,
  },
})
export default class Sustainability extends Report {
  async mounted() {
    await this.loadQuick('sustainability');
  }
}
